import { GET_PROFESSIONAL, GET_PROFESSIONAL_BY_ID } from "../constants/index";

export const professional = (
  state = { professionallist: [], professionalbyid: {} },
  action,
) => {
  switch (action.type) {
    case GET_PROFESSIONAL:
      return { ...state, professionallist: action.professionallist };
    case GET_PROFESSIONAL_BY_ID:
      return { ...state, professionalbyid: action.professionalbyid };
    default:
      return state;
  }
};
